import React from 'react';
import { IShapeProps } from './types';
import { IShapeStarAttributes } from '../../../types';
import { RegularPolygon } from 'react-konva';
import Konva from 'konva';

const RhombusCanvasElement: React.FC<IShapeProps> = (props) => {

  let attributes = (props.element.attributes as IShapeStarAttributes);
  const shapeRef = (props.shapeRef as React.MutableRefObject<Konva.RegularPolygon>);

  return (
    <RegularPolygon
      {...props.renderProps}
      ref={shapeRef}
      sides={4}
      radius={attributes.width! / 2}
    />
  );
}

export default RhombusCanvasElement